import '../../teacherTests.css';
import Button from "@common/Button";
import {Form, Select, Space, List, Radio, Divider, Checkbox, DatePicker, Table} from "antd";
import Card from "@common/Card"
import CollapsibleCard from "@common/CollapsibleCard"
import React, {useContext, useEffect, useMemo, useState} from "react";
import AssignedTestCard from "./testAssignments/AssignedTestCard";
import {UserContext} from "@context/UserContext";
import axios, {prepareAxiosParamsForStruts} from "@common/axios";
import GenericDialog from "@common/GenericDialog";
import {default as TooltipMUI} from "@mui/material/Tooltip";
import {HelpIcon} from "@common/icons";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import {RECIPIENT, RECIPIENT_ARR} from "../enums";
import ListAntD from "@common/ListAntD";
import {searchTestAssignmentsPaged} from "./axiosRequests";

const {Option} = Select;

const TestAssignments = (props) => {
    const {
            stepChange,
            updateSelectedTestAssignmentId,
            updateSelectedTestAssignmentData,
            updateSelectedClassIds,
            updateSelectedTestName,
            updateSelectedTestId,
            updateTestAssignmentClassMessage,
            updateTestAssignmentFeedbackDueDate,
            editAssignObj,
            resetTracking,
            refreshTestAssignmentSearch
        } = props,
        {user} = useContext(UserContext),
        {RangePicker} = DatePicker;

    const MY_CLASSES = 'MY_CLASSES',
        ALL_CLASSES = 'ALL_CLASSES',
        searchClassOptions = [{name: 'My classes', value: MY_CLASSES}, {name: 'All classes', value: ALL_CLASSES}],
        SearchOwnerObject = {MY_CLASSES: {value: 'CLASSES'}, ALL_CLASSES: {value: 'SCHOOL'}},
        TimePeriods = {
            TODAY: {name: 'Today', value: 'TODAY'},
            YESTERDAY: {name: 'Yesterday', value: 'YESTERDAY'},
            LAST_WEEK: {name: 'Last week', value: 'LAST_WEEK'},
            LAST_MONTH: {name: 'Last month', value: 'LAST_MONTH'},
            LAST_YEAR: {name: 'Last 12 months', value: 'LAST_YEAR'},
            ALL_TIME: {name: 'All time', value: 'ALL_TIME'}
        },
        searchTimePeriodOptions = [
            TimePeriods.TODAY,
            TimePeriods.YESTERDAY,
            TimePeriods.LAST_WEEK,
            TimePeriods.LAST_MONTH,
            TimePeriods.LAST_YEAR,
            TimePeriods.ALL_TIME
        ],
        searchPublishStates = {
            ACTIVE: {value: 'PUBLISHED', display: 'Active'},
            ARCHIVED: {value: 'ARCHIVED', display: 'Archived'}
        };

    const [searchTestAssignmentForm] = Form.useForm(),
        [editTestForm] = Form.useForm(),
        [assignedTestsParams, setAssignedTestsParams] = useState({}),
        [classIds, setClassIds] = useState([]),
        [searchClassIds, setSearchClassIds] = useState(user.classes.map(clazz => clazz.classId)),
        [formatValue, setFormatValue] = useState(editAssignObj.formatType.ASSESSMENT.val),
        [selectedAssignmentData, setSelectedAssignmentData] = useState(null),
        [selectedTestAssignmentId, setSelectedTestAssignmentId] = useState(null),
        [isLoading, setLoading] = useState(false),
        [isEditTestDialogOpen, setEditDialogOpen] = useState(false),
        [testOwnerSearchType, setTestOwnerSearchType] = useState(SearchOwnerObject.MY_CLASSES.value),
        [searchExpand, setSearchExpand] = useState(false),
        [studentIds, setStudentIds] = useState([]),
        [students, setStudents] = useState([]),
        [initialStudentIds, setInitialStudentIds] = useState([]),
        [triggerReload, setTriggerReload] = useState(null),
        initialClassIds = user.classes.map((clazz) => {
            return clazz.classId;
        }),
        [recipientState, setRecipientState] = useState(RECIPIENT.SINGLE_CLASS);
    const defaultTestResultsDialogData = {
        className: '',
        users: [],
        activeButtons: {reset: false, reassign: false, submit: false},
        totalSelectableUsers: 0
    };
    const [testResultsDialogData, setTestResultsDialogData] = useState(defaultTestResultsDialogData);

    const getTestResultsDialogData = (testAssignmentId, classId, className) => {
        axios.get('/web/ui/test/classTestResults', {params: {testAssignmentId: testAssignmentId, classId: classId}})
            .then(response => {
                if (response.data) {
                    let newTestResultsDialogData = defaultTestResultsDialogData;
                    let totalSelectableUsers = 0;
                    newTestResultsDialogData.className = className;
                    response.data.map(testResult => {
                        const selectableCheck = !testResult.open && !testResult.expired || (testResult.testAssignmentStatus === 'STARTED' || testResult.testAssignmentStatus === 'ABANDONED' || testResult.testAssignmentStatus === 'TIMED_OUT');
                        newTestResultsDialogData.users.push(Object.assign({}, testResult, {
                            selectable: selectableCheck,
                            selected: false
                        }));
                        if (selectableCheck) totalSelectableUsers++;
                    });
                    newTestResultsDialogData.totalSelectableUsers = totalSelectableUsers;
                    setTestResultsDialogData(newTestResultsDialogData);
                }
            });
    }

    const calculateTimeParams = (timePeriodValue)=>{
        let startDate,
            endDate;
        if(TimePeriods.TODAY.value === timePeriodValue){
            startDate = dayjs().startOf('day');
        }else if(TimePeriods.YESTERDAY.value === timePeriodValue){
            startDate = dayjs().subtract(1,'days').startOf('day');
        }else if(TimePeriods.LAST_WEEK.value === timePeriodValue){
            startDate = dayjs().subtract(7,'days').startOf('day');
        }else if(TimePeriods.LAST_MONTH.value === timePeriodValue){
            startDate = dayjs().subtract(1,'month').startOf('day');
        } else if (TimePeriods.LAST_YEAR.value === timePeriodValue) {
            startDate = dayjs().subtract(1, 'year').startOf('day');
        } else { // if(TimePeriods.ALL_TIME.value === timePeriodValue)
            startDate = undefined;
            endDate = undefined
        }

        return {startDate: startDate, endDate: endDate}
    }

    const handleClassesSelect = (newClassValue) => {
        setTestOwnerSearchType(SearchOwnerObject[newClassValue].value);
    }

    const handleClassChange = value => {
        setClassIds(value);
    }

    const handleClassSearchChange = value => {
        setSearchClassIds(value);
        searchTestAssignmentForm.setFieldsValue({['classIds']: value});
    }

    const handleAllClassSearchChange = (event) => {
        let newClazzIdsList = [];
        if (event.target.checked) {
            newClazzIdsList = user.classes.map(clazz => clazz.classId);
        }
        handleClassSearchChange(newClazzIdsList);
    }

    const onClassChange = (value) => {
        if (recipientState.value === RECIPIENT.SINGLE_CLASS.value) {
            if (value) {
                getStudentsInClass(value, true);
            } else {
                resetStudentDropDown();
            }
        }
    }

    useEffect(() => {
        if (refreshTestAssignmentSearch != null) {
            handleTriggerReload();
        }
    }, [refreshTestAssignmentSearch])

    const onFormatChange = ({target: {value}}) => {
        setFormatValue(value);
    }

    const handleSelectAllClassIds = event => {
        if (event.target.checked) {
            setClassIds(initialClassIds);
            editTestForm.setFieldsValue({['classIds']: initialClassIds});
        } else {
            clearClassSelect();
        }
    }

    const clearClassSelect = () => {
        editTestForm.setFieldsValue({['classIds']: []});
        setClassIds([]);
    }

    const editTestAssignment = async () => {
        setLoading(()=>{return true;});
        const fieldsValue = editTestForm.getFieldsValue();
        setSelectedAssignmentData(null);

        const params = {
            testAssignmentId: selectedTestAssignmentId,
            classIds: fieldsValue.classIds,
            all: true,
            testType: fieldsValue.format,
            note: fieldsValue.messageForStudents,
            showResultsOnExpiry: fieldsValue.showResultsOnExpiry,
            startDate: fieldsValue.dateRange[0].format(user.getDateTimeFormatString()),
            endDate: fieldsValue.dateRange[1].format(user.getDateTimeFormatString())
        }

        if (RECIPIENT.SINGLE_CLASS.value === recipientState.value && fieldsValue.studentIds.length !== initialStudentIds.length) {
            params.all = false;
            params.studentsInClass = fieldsValue.studentIds;
        }

        await axios.post('/controlCentre/updateTestAssignment.action', prepareAxiosParamsForStruts(params), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(response => {
                if (response.data.success) {
                    displayToastMessage('Test/s assignment updated successfully', response.data.message, 'success');
                } else {
                    displayToastMessage('Error updating test assignment', response.data.message, 'error');
                }
            }).catch((error) => {
                console.error('Error updating Test Assignment: ',error);
            }).finally(()=>{
                setLoading(false);
                handleTriggerReload();
            });
    }

    const handleTriggerReload = ()=>{
        setTriggerReload(new Date().getTime());
    }

    const updateAllSelectedDialogUsers = checked => {
        const updatedUsers = testResultsDialogData.users.map(testResult => {
            if (testResult.selectable) {
                return Object.assign({}, testResult, {
                    selected: checked
                });
            } else {
                return testResult;
            }
        });
        setTestResultsDialogData(Object.assign({}, testResultsDialogData, {
            users: updatedUsers,
            activeButtons: Object.assign({}, testResultsDialogData.activeButtons, buildActiveButtons(updatedUsers))
        }));
    }

    const updateSelectedDialogUsers = (userId, checked) => {
        const updatedUsers = testResultsDialogData.users.map(testResult => {
            if (testResult.userId === userId) {
                return Object.assign({}, testResult, {
                    selected: checked
                });
            } else {
                return testResult;
            }
        });
        setTestResultsDialogData(Object.assign({}, testResultsDialogData, {
            users: updatedUsers,
            activeButtons: Object.assign({}, testResultsDialogData.activeButtons, buildActiveButtons(updatedUsers))
        }));
    }

    const buildActiveButtons = users => {
        let showResetAndReassign = false;
        let showSubmit = false;
        users.filter(user => user.selected).forEach(testResult => {
            if (!testResult.open && !testResult.expired) showResetAndReassign = true;
            if (testResult.testAssignmentStatus === 'STARTED' || testResult.testAssignmentStatus === 'ABANDONED' || testResult.testAssignmentStatus === 'TIMED_OUT') showSubmit = true;
        });
        return {reset: showResetAndReassign, reassign: showResetAndReassign, submit: showSubmit};
    }

    const getResultsDialogButtonParams = () => {
        let studentIds = '';
        let testAssignmentId;
        testResultsDialogData.users.filter(user => user.selected).forEach(testResult => {
            studentIds += (studentIds === '' ? ',' : '') + testResult.userId;
            if (!testAssignmentId) testAssignmentId = testResult.testAssignmentId;
        });
        return {studentIds: studentIds, testAssignmentId: testAssignmentId};
    }

    const getStudentsInClass = (classId, populateStudentIds) => {
        axios.get('/web/ui/sc/studentsInClass', {params: {classId: classId}})
            .then(response => {
                if (response.data) {
                    const studentsData = response.data;
                    setStudents(studentsData);
                    const ids = [];
                    studentsData.forEach(student => {
                        ids.push(student.userId);
                    });
                    if(populateStudentIds) {
                        setStudentIds(ids);
                        editTestForm.setFieldsValue({['studentIds']: ids});
                    }
                    setInitialStudentIds(ids);
                }
            }).catch(error => {
            console.error('Error loading students. ', error);
        });

    }

    const onRecipientChange = ({target: {value}}) => {
        // console.log('value: ',value);
        let setVal = [],
            classVal = editTestForm.getFieldValue('classIds');
        if (value === RECIPIENT.MULTIPLE_CLASSES.value) {
            if (classVal !== undefined && !Array.isArray(classVal)) {
                setVal = [classVal];
            } else {
                setVal = classVal;
            }
            setRecipientState({...RECIPIENT.MULTIPLE_CLASSES});
        } else {
            if (classVal && classVal.length === 1 && classVal[0]) {
                setVal = classVal[0];
                getStudentsInClass(classVal[0], true);
            } else {
                setVal = undefined;
                resetStudentDropDown();
            }
            setRecipientState({...RECIPIENT.SINGLE_CLASS});
        }
        editTestForm.setFieldValue('classIds', setVal);
        setClassIds(setVal);
    }

    useEffect(()=>{
        searchTestAssignments();
    },[refreshTestAssignmentSearch])

    const searchTestAssignments = ()=>{
        setAssignedTestsParams(getTestAssignmentsParams());
    }

    useEffect(() => {
        if (selectedAssignmentData != null) {
            setSelectedTestAssignmentId(selectedAssignmentData.testAssignmentId);
            setClassIds(selectedAssignmentData.classIds);
            if (selectedAssignmentData.assignedToStudents) {
                getStudentsInClass(selectedAssignmentData.classIds[0], false);
            }
            if (selectedAssignmentData.studentIds) {
                setStudentIds(selectedAssignmentData.studentIds);
            }
            editTestForm.setFieldsValue({
                format: selectedAssignmentData.testType,
                messageForStudents: selectedAssignmentData.note,
                dateRange: [dayjs(selectedAssignmentData.startDate), dayjs(selectedAssignmentData.endDate)],
                classIds: selectedAssignmentData.classIds,
                studentIds: selectedAssignmentData.studentIds,
                showResultsOnExpiry: selectedAssignmentData.showResultsOnExpiry,
                recipient: selectedAssignmentData.assignedToStudents ? RECIPIENT.SINGLE_CLASS.value : RECIPIENT.MULTIPLE_CLASSES.value
            });
            onRecipientChange({target:selectedAssignmentData.assignedToStudents ? RECIPIENT.SINGLE_CLASS : RECIPIENT.MULTIPLE_CLASSES});
        } else {
            setSelectedTestAssignmentId(null);
            setClassIds([]);
            resetStudentDropDown();
        }
        setEditDialogOpen(selectedAssignmentData != null);
    }, [selectedAssignmentData]);


    const resetStudentDropDown = () => {
        setStudents([])
        setStudentIds([]);
        setInitialStudentIds([]);
        editTestForm.setFieldsValue({['studentIds']: []});
    }

    const handleStudentChange = value => {
        setStudentIds(value);
    }

    const handleSelectAllStudentIds = event => {
        if (event.target.checked) {
            setStudentIds(initialStudentIds);
            editTestForm.setFieldsValue({['studentIds']: initialStudentIds});
        } else {
            deselectAllStudentSelect();
        }
    }

    const deselectAllStudentSelect = () => {
        editTestForm.setFieldsValue({['studentIds']: []});
        setStudentIds([]);
    }

    const handleSelectedAssignmentData = (value) => {
        setSelectedAssignmentData(value)
    }



    const getTestAssignmentsParams = () => {

        if (testOwnerSearchType === SearchOwnerObject.MY_CLASSES.value && user.classes.length === 0) {
            displayToastMessage('Classes', 'No classes have been found', 'error', undefined, 10000);
            // setLoading(false);
            return {};
        }

        const {startDate, endDate} = calculateTimeParams(searchTestAssignmentForm.getFieldValue('timePeriod')),
            params = {
                testPurpose: 'DIAGNOSTIC_TEST',
                startDate: startDate,
                endDate: endDate,
                archived: searchPublishStates.ARCHIVED.value === searchTestAssignmentForm.getFieldValue('publishState'),
                classIds: searchClassIds
            };


        // if (testOwnerSearchType === SearchOwnerObject.MY_CLASSES.value) {
        //     params.classIds = initialClassIds;
        // }

        params.addResults = true;
        params.pageSize = 5;
        return params;
    }

    const handleSetLoading = (val)=>{
        setLoading(val);
    }

    return (
        <div>
            <Space orientation="horizontal" size="middle" style={{marginBottom: '6px'}}>
                <h2>Assigned tests</h2>
            </Space>
            <Space orientation="vertical" size="small"
                   style={{display: 'flex', justifyContent: 'space-between', lineHeight: 'normal'}}>
                <CollapsibleCard id="testAssignmentSearchBox" title={'Search'}>
                    <Form
                        form={searchTestAssignmentForm}
                        initialValues={{
                            timePeriod: 'LAST_YEAR',
                            classes: 'MY_CLASSES',
                            publishState: searchPublishStates.ACTIVE.value,
                            classIds: searchClassIds
                        }}
                        style={{display: 'flex', gap: '8px', alignItems: 'center'}}
                    >
                        <Form.Item
                            name="classIds"
                        >
                            <Select
                                size="small"
                                style={{minWidth: '400px', width: 'fit-content'}}
                                virtual={false}
                                popupRender={menu => (
                                    <div>
                                        {menu}
                                        <Divider className='margin-b--rm'/>
                                        <Checkbox
                                            className={'padding--m'}
                                            disabled={user.classes.length === 0}
                                            checked={searchClassIds.length === user.classes.length}
                                            onChange={handleAllClassSearchChange}
                                        >
                                            Select all students
                                        </Checkbox>
                                    </div>
                                )}
                                showSearch={false}
                                showarrow={'true'}
                                allowClear={true}
                                autoClearSearchValue={true}
                                onChange={handleClassSearchChange}
                                mode="multiple"
                                maxTagCount="responsive"
                                getPopupContainer={trigger => trigger.parentElement}
                            >
                                {user.classes.sort((a, b) => a.className.localeCompare(b.className)).map((clazz) => (
                                    <Select.Option key={clazz.classId} value={clazz.classId}>
                                        {clazz.className}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="timePeriod"
                        >
                            <Select virtual={false} autoClearSearchValue={true}
                                    size="small"
                                    style={{minWidth: '140px'}}
                                    getPopupContainer={trigger => trigger.parentElement}
                            >
                                {searchTimePeriodOptions.map((timePeriod) => {
                                    return <Option key={timePeriod.value}
                                                   value={timePeriod.value}>{timePeriod.name}</Option>;
                                })}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="publishState"
                        >
                            <Select virtual={false} autoClearSearchValue={true}
                                    size="small"
                                    style={{minWidth: '140px'}}
                                    getPopupContainer={trigger => trigger.parentElement}
                            >
                                {Object.values(searchPublishStates).map((publishState) => {
                                    return <Option key={publishState.value} value={publishState.value}>{publishState.display}</Option>;
                                })}
                            </Select>
                        </Form.Item>
                        <Button size="small" onClick={searchTestAssignments}>Search</Button>
                    </Form>
                </CollapsibleCard>
                    <ListAntD id="testAssignmentsFollowUp" showBackgroundOnHover={false} removeListPadding={true} pagingDependencies={[assignedTestsParams]} pagingData={{fetchFunction:searchTestAssignmentsPaged, params:assignedTestsParams}} reload={triggerReload} loading={isLoading} renderItem={(item) => (
                        <AssignedTestCard key={item.testAssignmentId}
                                          data={item}
                                          stepChange={stepChange}
                                          triggerReload={handleTriggerReload}
                                          updateSelectedTestAssignmentId={updateSelectedTestAssignmentId}
                                          updateSelectedTestAssignmentData={updateSelectedTestAssignmentData}
                                          updateSelectedClassIds={updateSelectedClassIds}
                                          updateSelectedTestName={updateSelectedTestName}
                                          updateSelectedTestId={updateSelectedTestId}
                                          updateTestAssignmentClassMessage={updateTestAssignmentClassMessage}
                                          updateTestAssignmentFeedbackDueDate={updateTestAssignmentFeedbackDueDate}
                                          // searchTestAssignments={searchTestAssignments}
                                          updateSelectedAssignmentData={handleSelectedAssignmentData}
                                          updateSetLoading={handleSetLoading}
                                          updateTestResultsDialogData={getTestResultsDialogData}
                                          resetTracking={resetTracking}
                        />
                    )} />
            </Space>
            <GenericDialog title={'Edit Test Assignment'} open={isEditTestDialogOpen}
                           contentStyle={{width: 600}}
                           onClose={() => {
                               setSelectedAssignmentData(null);
                           }}
                           buttons={[
                               {
                                   name: 'Cancel',
                                   extraProps: {type: 'text'}
                               },
                               {
                                   name: 'Update',
                                   callback: editTestAssignment
                               }]}>
                <div className={'dialog-form-tooltip-wrapper'} style={{left: 182, top: 50}}>
                    <TooltipMUI placement={"top"} title={editAssignObj.START_END_DATE_TOOLTIP}>
                <span>
                    <HelpIcon sx={{m: 1}} style={{
                        verticalAlign: 'middle',
                        marginLeft: '36px',
                        width: '16px',
                        height: '16px'
                    }}/>
                </span>
                    </TooltipMUI>
                </div>
                <div className={'dialog-form-tooltip-wrapper'} style={{left: 182, top: 138}}>
                    <TooltipMUI placement={"top"} title={editAssignObj.SHOW_RESULTS_ON_EXPIRY_TOOLTIP}>
                    <span>
                        <HelpIcon sx={{m: 1}} style={{
                            verticalAlign: 'middle',
                            marginLeft: '36px',
                            width: '16px',
                            height: '16px'
                        }}/>
                    </span>
                    </TooltipMUI>
                </div>
                <Form
                    className={"testFamilyForm editAssignTestForm"}
                    form={editTestForm}
                    labelCol={{span: 9}}
                    wrapperCol={{span: 15}}
                    labelWrap
                >
                    {selectedAssignmentData != null && selectedAssignmentData.inProgress &&
                        <Form.Item
                            label={"Choose format"}
                            name={"format"}
                        >
                            <div className={'test-inprogress'}>
                                {editAssignObj.formatType.ASSESSMENT.name}
                            </div>
                        </Form.Item>
                    }
                    {selectedAssignmentData == null || (!selectedAssignmentData.inProgress) && <Form.Item
                        label={"Choose format"}
                        name={"format"}
                    >
                        <Radio.Group
                            optionType="button"
                            onChange={onFormatChange}
                            buttonStyle={'solid'}
                            options={
                                [{
                                    label: editAssignObj.formatType.ASSESSMENT.name,
                                    value: editAssignObj.formatType.ASSESSMENT.val,
                                    style: {textAlign: 'center', width: '50%'}
                                },
                                    {
                                        label: editAssignObj.formatType.REVISION.name,
                                        value: editAssignObj.formatType.REVISION.val,
                                        style: {textAlign: 'center', width: '50%'}
                                    }]
                            }
                        />
                    </Form.Item>
                    }
                    <Form.Item
                        label={"Dates between"}
                        name={"dateRange"}
                        rules={[
                            {
                                required: true,
                                message: 'Please select start and end date.',
                            }, {
                                validator: (_, dates) => {
                                    if (dates && dates.length < 2) {
                                        return Promise.reject('Start and end date required.');
                                    } else {
                                        return Promise.resolve();
                                    }
                                },
                                message: 'Please select start and end date.',
                            },
                        ]}
                    >
                        <RangePicker
                            showTime={{
                                format: 'HH:mm'
                            }}
                            format={user.getDateTimeFormatString()}
                            placement="topLeft"
                            disabled={[selectedAssignmentData != null && selectedAssignmentData.inProgress, false]}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Allow students to view results"
                        name="showResultsOnExpiry"
                    >
                        <Radio.Group
                            optionType="button"
                            options={[
                                {label: 'Yes', value: true},
                                {label: 'No', value: false}]
                            }/>
                    </Form.Item>
                    <Form.Item
                        label="Message for students"
                        name="messageForStudents"
                    >
                        <TextArea rows={4}/>
                    </Form.Item>
                    {selectedAssignmentData != null && selectedAssignmentData.inProgress &&
                        <Form.Item
                            label="Classes"
                            name="classIds"
                        >
                            <>
                                {selectedAssignmentData.classes.map((clazz, index) => {
                                    const connector = index === 0 ? '' : ', ';
                                    return (
                                        <span key={clazz.classId}
                                              className={'test-inprogress'}>{connector + clazz.className}</span>
                                    )
                                })}
                            </>
                        </Form.Item>
                    }
                    <Form.Item
                        label={"Recipient"}
                        name={"recipient"}
                        hidden={!(selectedAssignmentData == null || (!selectedAssignmentData.inProgress))}
                    >
                        <Radio.Group
                            optionType="button"
                            onChange={onRecipientChange}
                            options={
                                RECIPIENT_ARR.map((child) => {
                                    return {key: child.val, label: child.display, value: child.value};
                                })}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Classes"
                        name="classIds"
                        hidden={!(selectedAssignmentData == null || (!selectedAssignmentData.inProgress))}
                        rules={[
                            {
                                required: true,
                                message: 'Select at least one class.',
                            },
                            {
                                message: 'Maximum 5 classes.',
                                validator: (_, classIds) => {
                                    if (classIds && classIds.length > 0 && classIds.length > 5) {
                                        return Promise.reject('You can only assign a maximum of 5 classes.');
                                    } else {
                                        return Promise.resolve();
                                    }
                                }
                            }
                        ]}
                    >
                        <Select onSelect={onClassChange} virtual={false} showSearch={false} showarrow={"true"}
                                popupRender={menu => (
                                    <>
                                        {menu}
                                        <Divider style={{margin: '0 0 4px 0'}}/>
                                        <div className={'edit-assign-dialog select-checkbox-wrapper'}>
                                            <Checkbox disabled={initialClassIds && initialClassIds.length === 0}
                                                      value={classIds}
                                                      defaultChecked={true}
                                                      checked={initialClassIds && classIds && initialClassIds.length === classIds.length}
                                                      onChange={handleSelectAllClassIds}>Select all
                                                classes</Checkbox>
                                        </div>
                                    </>
                                )} allowClear autoClearSearchValue={true}
                            // onSelect={handleStudentSelect} onDeselect={handleStudentDeselect}
                                onChange={handleClassChange}
                                onClear={resetStudentDropDown}
                                mode={recipientState.multipleDropDown ? 'multiple' : ''} maxTagCount='responsive'>
                            {user.classes.map((clazz) => {
                                return <Select.Option key={clazz.classId}
                                                      value={clazz.classId}>{clazz.className}</Select.Option>;
                            })}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Students"
                        name="studentIds"
                        hidden={!(selectedAssignmentData == null || (!selectedAssignmentData.inProgress) && recipientState.value === RECIPIENT.SINGLE_CLASS.value)}
                        rules={[
                            {
                                required: true,
                                message: 'Select at least one student.',
                            }
                        ]}
                    >
                        <Select virtual={false} showSearch={false} showarrow={"true"} popupRender={menu => (
                            <>
                                {menu}
                                <Divider style={{margin: '0 0 4px 0'}}/>
                                <div className={'edit-assign-dialog select-checkbox-wrapper'}>
                                    <Checkbox disabled={initialStudentIds.length === 0} value={studentIds}
                                              defaultChecked={true}
                                              checked={initialStudentIds.length === studentIds.length}
                                              onChange={handleSelectAllStudentIds}>Select all
                                        students</Checkbox>
                                </div>
                            </>
                        )} allowClear autoClearSearchValue={true}
                                onChange={handleStudentChange}
                                mode="multiple" maxTagCount="responsive">
                            {students.map((student) => {
                                return <Option key={student.userId}
                                               value={student.userId}>{student.fullName}</Option>;
                            })}
                        </Select>
                    </Form.Item>
                </Form>
            </GenericDialog>
            <GenericDialog
                open={testResultsDialogData.users.length > 0}
                title={testResultsDialogData.className}
                contentStyle={{width: 460}}
                onClose={() => {
                    setTestResultsDialogData(defaultTestResultsDialogData);
                }}
                buttons={[
                    {
                        name: 'Reset',
                        disabled: !testResultsDialogData.activeButtons.reset,
                        callback: async () => {
                            axios.post('/controlCentre/resetTestToStudents.action', null, {params: getResultsDialogButtonParams()})
                                .then(response => {
                                    if (response.data && response.data.success) {
                                        setTestResultsDialogData(defaultTestResultsDialogData);
                                        // searchTestAssignments();
                                    }
                                });
                        }
                    }, {
                        name: 'Reassign',
                        disabled: !testResultsDialogData.activeButtons.reassign,
                        callback: async () => {
                            axios.post('/controlCentre/reassignTestToStudents.action', null, {params: getResultsDialogButtonParams()})
                                .then(response => {
                                    if (response.data && response.data.success) {
                                        setTestResultsDialogData(defaultTestResultsDialogData);
                                        // searchTestAssignments();
                                    }
                                })
                        }
                    }, {
                        name: 'Submit',
                        disabled: !testResultsDialogData.activeButtons.submit,
                        callback: async () => {
                            axios.post('/controlCentre/finalizeTestAssignmentForStudents.action', null, {params: getResultsDialogButtonParams()})
                                .then(response => {
                                    if (response.data && response.data.success) {
                                        setTestResultsDialogData(defaultTestResultsDialogData);
                                        // searchTestAssignments();
                                    }
                                })
                        }
                    }, {name: 'Close'}
                ]}>
                <div className="ch-dataTable ch-general-table-antd margin-t--rm">
                    <Table className=''
                           columns={[
                               ...(testResultsDialogData.totalSelectableUsers > 0 ? [
                                   {
                                       title: testResultsDialogData.totalSelectableUsers > 0 ? (
                                           <Checkbox
                                               indeterminate={testResultsDialogData.users.filter(user => user.selected).length > 0 && testResultsDialogData.users.filter(user => user.selected).length < testResultsDialogData.totalSelectableUsers}
                                               checked={testResultsDialogData.users.filter(user => user.selected).length === testResultsDialogData.totalSelectableUsers}
                                               onChange={event => updateAllSelectedDialogUsers(event.target.checked)}
                                           />
                                       ) : (<>&nbsp;</>),
                                       dataIndex: 'selectable',
                                       key: 'selectable',
                                       render: (text, record) => (
                                           record.selectable && testResultsDialogData.totalSelectableUsers > 0 ? (
                                               <Checkbox
                                                   checked={record.selected}
                                                   onChange={event => updateSelectedDialogUsers(record.userId, event.target.checked)}
                                               />
                                           ) : (<>&nbsp;</>)
                                       )
                                   }] : []),
                               {title: 'Student', dataIndex: 'student', key: 'student'},
                               {title: 'Test', dataIndex: 'test', key: 'test'}
                           ]}
                           dataSource={testResultsDialogData.users.map((testResult, index) => {
                               return {
                                   key: index,
                                   student: (testResult.lastName + ", " + testResult.firstName),
                                   test: (testResult.testAssignmentStatus.substr(0, 1) + testResult.testAssignmentStatus.substr(1).toLowerCase()),
                                   selectable: testResultsDialogData.totalSelectableUsers > 0 && testResult.selectable,
                                   selected: testResult.selected,
                                   userId: testResult.userId
                               }
                           })}
                           pagination={{hideOnSinglePage: true}}
                    />
                </div>
                <p className='ch-text-small'>
                    <span className='ch-text-b'>Reset: </span>answers will be removed, <span
                    className='ch-text-b'>Reassign: </span>answers will be kept, <span
                    className='ch-text-b'>Submit: </span>answers will be submitted
                </p>
            </GenericDialog>
        </div>
    )
}
export default TestAssignments;
